var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60999 14.3324L7.93498 16.1324C8.23498 16.4324 8.90998 16.5824 9.35998 16.5824H12.21C13.11 16.5824 14.085 15.9074 14.31 15.0074L16.11 9.53242C16.485 8.48242 15.81 7.58242 14.685 7.58242H11.685C11.235 7.58242 10.86 7.20742 10.935 6.68242L11.31 4.28242C11.46 3.60742 11.01 2.85742 10.335 2.63242C9.73498 2.40742 8.98498 2.70742 8.68498 3.15742L5.60999 7.73242",
    stroke: "#132A3A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78503 14.3324V6.98237C1.78503 5.93237 2.23503 5.55737 3.28503 5.55737H4.03503C5.08503 5.55737 5.53503 5.93237 5.53503 6.98237V14.3324C5.53503 15.3824 5.08503 15.7574 4.03503 15.7574H3.28503C2.23503 15.7574 1.78503 15.3824 1.78503 14.3324Z",
    stroke: "#132A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3e26fa87988ac8cf344afff774b1a9b5.svg";
export { ForwardRef as ReactComponent };